import React from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import { Link } from "react-router-dom";

function Detail() {
    return (
        <>
            <Header />

            <main>
                {/*===== HERO AREA START =====*/}
                <div
                    className="inner-hero"
                    style={{ backgroundImage: "url(assets/img/bg/Ashok.jpg)" }}
                >
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-8 m-auto text-center">
                                <div className="inner-main-heading">
                                    <h1>Blog Detail</h1>
                                    <div className="breadcrumbs-pages">
                                        {/* <ul>
                <li>
                  <a href="index.html">Home</a>
                </li>
                <li className="angle">
                  <i className="fa-solid fa-angle-right" />
                </li>
                <li>Daily Blog</li>
              </ul> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/*===== HERO AREA START =====*/}
                {/*===== BLOG DETAILS AREA START =====*/}
                <div className="blog-details-area sp">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-8 m-auto">
                                <div className="blog-details-content">
                                    <article>
                                        <div className="details-content">
                                            <div className="image">
                                                <img
                                                    className="w-full"
                                                    src="assets/img/blog/b1.jpg"
                                                    alt=""
                                                />
                                            </div>
                                            {/* <div className="vl-blog12-meta mt-24">
                                                <a href="#" className="date">
                                                    <img src="assets/img/icons/date1.svg" alt="" /> 12/12/2025
                                                </a>
                                                <a href="#" className="author">
                                                    <img src="assets/img/icons/author1.svg" alt="" /> John Doe
                                                </a>
                                            </div> */}
                                            <div className="heading2 mt-24">
                                                <h3>
                                                   The Silent Wounds of Sympathy

                                                </h3>
                                                <p className=" mt-16">
                                                    There’s a certain kind of kindness that wounds more than it heals.
                                                    “The society looks down upon orphans and tries to be sympathetic. As children they appreciate the sympathy. But as they grow old, they hate that sympathy. They develop strong inferiority complex. They have complexes to sit with others. A fear to talk with people from decent families in a normal manner. Hence they pick up a hoarse style of communication. They dislike mannerisms. They hate to be children without known parents. They hate to have been sympathized. The hatred towards their own situation makes their mind pervert. They become rowdy.”
                                                </p>
                                                <br></br>

                                                <p>

                                                    These words cut deep because they are true in a way society rarely wants to admit. Behind the nods of pity and gentle words lies an unspoken assumption that someone without parents is somehow less complete, less whole. It begins innocently enough, with adults offering special attention, extra kindness, and hushed conversations meant to “spare” the child. At first, the orphaned child may even welcome this; it feels like warmth in a world that has taken so much away.


                                                </p>
                                                <br></br>

                                                <p>
                                                    But as the years pass, that sympathy changes flavor.
                                                    When Sympathy Turns into a Cage
                                                    We often assume that sympathy is always a good thing. But sympathy is not the same as respect. For an orphan growing up, the constant reminder of their “different” status becomes a quiet, heavy burden. The child learns early that they are being treated with kindness not because they are equal, but because they are seen as someone to be pitied.
                                                </p>
                                                <br></br>

                                                <p>

                                                    This pity seeps into interactions. Sitting with peers becomes awkward. Conversation becomes guarded. There’s a fear of saying the wrong thing, of not knowing the “normal” codes of family life. And when they feel excluded from that invisible circle of belonging, many develop defense mechanisms; a rough tone, a deliberate disregard for “polite” behavior, a rejection of societal mannerisms.

                                                </p>
                                                <br></br>

                                                <p>
It’s not because they lack refinement, but because refinement feels like a disguise they were never allowed to wear without being questioned. Slowly, the kindness they once accepted turns into a mirror of their difference, and they begin to hate the reflection.
The Turning Point: Hatred, Rebellion, and the Quest for Dignity
By adulthood, that accumulated resentment can harden. The hatred isn’t just towards society, it’s also towards their own situation. It’s toward being “the one without parents,” toward the years of being handled differently, toward the identity they never chose but had to live under every single day.


                                                </p>
                                                <br></br>
                                                <p>

                                                    For some, this turns inward, becoming an inferiority complex. For others, it bursts outward, fueling rebellious behavior. When dignity is denied for so long, rebellion becomes a way to claim it back; even if it emerges as aggression, rowdiness, or defiance of social norms. It’s not so much hatred for people as it is hatred for the role society has forced them to play.

And this is where, as a community, we must see our mistakes clearly: pity does not lift people up. Equality and respect do. A child without parents does not need to be marked by sympathy for life. They need to be seen as capable, whole, and valuable for who they are, not defined by what they lost.
                                                </p>

                                                <br></br>

<p>

   Why Should You Read The Book?
In Seru My Love, the voice of the street dog who judges no one by their background is a stark contrast to human society’s rigid ways. Seru doesn’t care whether someone has a surname, a family history, or a polished upbringing. He cares only about the person before him, their warmth, their kindness, their presence.

Maybe it’s time we learn from animals like Seru. If we replaced pity with acceptance, sympathy with opportunity, and judgment with genuine inclusion, perhaps fewer people would carry the silent wounds that turn into rebellion.
Because at the heart of it, no one wants to be “the pitiable one.” Everyone wants to be simply… human. 
</p>

                                            </div>


                                        </div>
                                    </article>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/*===== BLOG DETAILS AREA END =====*/}

            </main>


            <Footer />
        </>
    );
}

export default Detail;
